/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';

import Text from 'solis/react/primitive/text';

import Section from 'solis/claude/primitive/section';

import Row from 'solis/claude/card/deploy/row';


const getDeployableColonies = (galaxy, account) =>
{
  const colonies = account.getCurrentColonyViews().values().map(view => galaxy.getColony(view.cass.colony)).filter(colony => colony !== null);

  return colonies.filter(colony => colony.cass.user === account.cass.id && !colony.cass.board);
};


const Component = ({ colonies }) =>
(
  <Card>
    <Flex direction = 'column' gap = '3'>

      <Section label = 'Next move'>
        <Text size = '3' weight = 'medium'>Deploy a colony.</Text>
      </Section>

      <Text.Note>Create a board for other players to attack, or attack one of theirs. A board scores when it ends.</Text.Note>

      <Flex direction = 'column' gap = '2'>
        {colonies.map(colony => <Row key = {colony.cass.id} colony = {colony} />)}
      </Flex>

    </Flex>
  </Card>
);


export default () =>
{
  const galaxy = use(Galaxy);

  const colonies = getDeployableColonies(galaxy, galaxy.getCurrentAccount());

  if (colonies.length === 0)
  {
    return null;
  }

  return <Component colonies = {colonies} />;
};
